import PageShell from "@/components/site/PageShell";

export default function Treasures2026() {
  return (
    <PageShell>
      <section className="bg-white min-h-[80vh] flex items-center py-24 md:py-32">
        <div className="max-w-6xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center w-full">
          {/* The "?" cover card */}
          <div className="lg:col-span-6 reveal">
            <div
              data-testid="treasures-question-card"
              className="zoom-wrap aspect-[16/10] w-full"
            >
              <img
                src="/treasures-2026-cover.jpg"
                alt="Treasures 2026"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Single COMING SOON headline */}
          <div className="lg:col-span-6 text-center lg:text-left reveal delay-1">
            <h1
              data-testid="treasures-coming-soon"
              className="font-display text-[#1a365d] text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[1.02] tracking-tight font-medium"
            >
              Coming <span className="italic">soon.</span>
            </h1>
            <span
              aria-hidden
              className="mt-8 inline-block h-[2px] w-16 bg-[#d4af37]"
            />
          </div>
        </div>
      </section>
    </PageShell>
  );
}
